import * as yup from 'yup';
import { sharedInterascoFields } from '@/views/checkouts/companies/Interasco/shared/sharedInterascoSchema';

export const CarInterascoSchemaBuilder = (
    firstDriverAdditionalPremiumAge,
    secondDriverAdditionalPremiumAge,
    firstDriverAdditionalPremiumLicenseYears,
    secondDriverAdditionalPremiumLicenseYears,
    legalEntity,
    secondDriver,
    discountEntity,
    vehicleType
) => {
    return yup.object({
        ...sharedInterascoFields(
            firstDriverAdditionalPremiumAge,
            secondDriverAdditionalPremiumAge,
            firstDriverAdditionalPremiumLicenseYears,
            secondDriverAdditionalPremiumLicenseYears,
            legalEntity,
            secondDriver,
            discountEntity,
            vehicleType
        ),
    });
};

export default CarInterascoSchemaBuilder;
